import React from 'react';

const CheckboxIcon = ({ inputType }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      x='0'
      y='0'
      enableBackground='new 0 0 15 15'
      version='1.1'
      viewBox='0 0 474.8 474.801'
      xmlSpace='preserve'
      fill={inputType == 'checkbox' ? '#374176' : '#6b6b6b'}
    >
      <path d='M396.283 257.097c-1.14-.575-2.282-.862-3.433-.862-2.478 0-4.661.951-6.563 2.857l-18.274 18.271c-1.708 1.715-2.566 3.806-2.566 6.283v72.513c0 12.565-4.463 23.314-13.415 32.264-8.945 8.945-19.701 13.418-32.264 13.418H82.226c-12.564 0-23.319-4.473-32.264-13.418-8.947-8.949-13.418-19.698-13.418-32.264V118.622c0-12.562 4.471-23.316 13.418-32.264 8.945-8.946 19.7-13.418 32.264-13.418H319.77c4.188 0 8.47.571 12.847 1.714 1.143.378 1.999.571 2.563.571 2.478 0 4.668-.949 6.57-2.852l13.99-13.99c2.282-2.281 3.142-5.043 2.566-8.276-.571-3.046-2.286-5.236-5.141-6.567-10.272-4.752-21.412-7.139-33.403-7.139H82.226c-22.65 0-42.018 8.042-58.102 24.126C8.042 76.613 0 95.978 0 118.629v237.543c0 22.647 8.042 42.014 24.125 58.098 16.084 16.088 35.452 24.13 58.102 24.13h237.541c22.647 0 42.017-8.042 58.101-24.13 16.085-16.084 24.134-35.45 24.134-58.098v-90.797c-.002-3.994-1.915-6.752-5.72-8.278z'></path>
      <path d='M467.95 93.216l-31.409-31.409c-4.568-4.567-9.996-6.851-16.279-6.851-6.275 0-11.707 2.284-16.271 6.851L219.265 246.532l-75.084-75.089c-4.569-4.57-9.995-6.851-16.274-6.851-6.28 0-11.704 2.281-16.274 6.851l-31.405 31.405c-4.568 4.568-6.854 9.994-6.854 16.277 0 6.28 2.286 11.704 6.854 16.274l122.767 122.767c4.569 4.571 9.995 6.851 16.274 6.851 6.279 0 11.704-2.279 16.274-6.851l232.404-232.403c4.565-4.567 6.854-9.994 6.854-16.274s-2.283-11.706-6.851-16.273z'></path>
    </svg>
  );
};

export default CheckboxIcon;
